export default "__VITE_ASSET__OhI3GDVI__"